import React from 'react';
import {IconButton} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Box from '@mui/material/Box';
import {setColumnSortDirection, getColumnSortDirection} from './technicalMapTabletFilterUtils';

const TechnicalMapTabletFilterSortButtons = ({columnId, sorting, onSortingChange}) => {
    const direction = getColumnSortDirection(sorting, columnId);

    const handleSort = (nextDirection) => {
        onSortingChange(setColumnSortDirection(sorting, columnId, nextDirection));
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexShrink: 0,
                alignItems: 'center',
                gap: '4px',
            }}
        >
            <IconButton
                size="small"
                aria-label="Сортировать по возрастанию"
                onClick={() => handleSort('asc')}
                sx={{
                    p: '4px',
                    color: direction === 'asc' ? 'primary.main' : '#737478',
                }}
            >
                <ArrowUpwardIcon sx={{fontSize: 24}}/>
            </IconButton>
            <IconButton
                size="small"
                aria-label="Сортировать по убыванию"
                onClick={() => handleSort('desc')}
                sx={{
                    p: '4px',
                    color: direction === 'desc' ? 'primary.main' : '#737478',
                }}
            >
                <ArrowDownwardIcon sx={{fontSize: 24}}/>
            </IconButton>
        </Box>
    );
};

export default TechnicalMapTabletFilterSortButtons;
